// school-ai/src/i18n/locales/ja.ts
export const ja = {
  common: {
    schoolAi: "スクールAI",
    welcome: "ようこそ",
    loading: "読み込み中...",
    error: "エラーが発生しました",
    save: "保存",
    cancel: "キャンセル",
    close: "閉じる",
    submit: "送信",
    language: "言語",
    search: "検索",
    mode: "アプリ",
    teacherLabel: "先生用",
    logout: "ログアウト"
  },
  chat: {
    displayModes: "アプリ一覧を表示",
    userInput: "ユーザー入力",
    searchModes: "アプリを検索",
    start: "はじめる",
    restartConversation: "会話をやり直す",
    tapToReply: "返信をかく",
    wordCount: "文字",
    imageToText: "画像 ▷ 文字",
    printChat: "チャット全体を印刷",
    submitChat: "チャット全体を提出",
    submitRecord: "記録提出(試験運用中)",
    confirmationForUsage: "使い方を確認したので",
    startChat: "スタート",
    searchChatByDate: "日付で会話を検索",
    submissionList: "提出ボックス一覧",
    selectSubmissionDestination: "提出先を選択",
    submissionDescription: "チャットは選択した提出先に提出されます",
    withdrawnLabel: "取り下げ済",
    submit: "提出する",
    noSubmissionBoxMessage: "提出ボックスがありません",
    pronunciationSubmissionDescription:
      "発音評価の結果は選択した提出先に提出されます"
  },
  navigation: {
    home: "ホーム",
    studentGuide: "生徒用ガイド",
    myPage: "マイページ",
    manageModes: "アプリ管理",
    submission: "提出管理",
    discover: "アプリをみつける",
    manual: "公式ガイド",
    contact: "お問い合わせ"
  },
  myPage: {
    myPageTitle: "マイページ",
    editMyPageInfo: "基本情報を編集する",
    updatePasswordFirstHalf: "ログインパスワード",
    updatePasswordSecondHalf: "変更",
    name: "名前",
    studentId: "生徒ID",
    studentLoginId: "ログインID",
    schoolId: "スクールID",
    schoolName: "スクール名",
    classroomName: "教室名",
    grade: "学年",
    freeInput: "自由記入欄",
    email: "メールアドレス"
  },
  login: {
    agreeToTermsText: {
      withLogin: "ログインを以て",
      privacyPolicy: "プライバシーポリシー",
      and: "および",
      termsOfService: "利用規約",
      agree: "に同意します"
    },
    qrLoginText: "生徒ログイン用QRコードをスキャンしてログインする",
    or: "または",
    schoolId: "スクールID",
    studentLoginId: "生徒ログインID",
    email: "メールアドレス",
    password: "パスワード",
    loginWithStudentId: "生徒ログインIDでログインする",
    loginWithEmail: "メールアドレスでログイン",
    loginWithGoogle: "Googleでログイン",
    loginWithMicrosoft: "Microsoftでログイン",
    here: "こちら",
    hereCapital: "こちら",
    toLoginForTeachers: "先生用のログイン画面は",
    toLoginForStudents: "生徒用のログイン画面は",
    inCaseSchoolIdMissing: "スクールIDが分からない場合は",
    noAccountMessage:
      "アカウントをまだお持ちでない方は先生に相談してください。",
    resetPassword: "パスワードをリセット",
    showPassword: "パスワードを表示",
    hidePassword: "パスワードを隠す",
    qrCameraError:
      "カメラを起動できませんでした。カメラの使用を許可するか、IDとパスワードでログインしてください。",
    passwordReset: {
      title: "パスワードリセット",
      description:
        "パスワードをリセットしたいアカウントのメールアドレスを入力してください。再設定用のリンクをお送りします。",
      cancel: "キャンセル",
      send: "送信する",
      success:
        "パスワード再設定用のメールを送信しました。メールボックスをご確認ください。",
      failure:
        "メールを送信できませんでした。時間をおいてもう一度お試しください。"
    },
    teacherLanding: {
      headlineStart: "ようこそ、",
      headlineAccent: "スクールAI",
      headlineEnd: "へ。",
      teacherDescription: "ご利用の先生アカウントでログインしてください。",
      studentDescription: "ご利用の生徒アカウントでログインしてください。",
      teacherTab: "先生",
      studentTab: "生徒",
      cardTitle: "おかえりなさい、先生。",
      cardDescription:
        "メールアドレスでログインして、今日の授業を始めましょう。",
      forgotPassword: "忘れましたか？"
    },
    studentLanding: {
      cardTitle: "おかえりなさい。",
      cardDescription: "QRコードかIDとパスワードで、学びを続けましょう。",
      qrTitle: "QRコードでログイン",
      qrDescription: "先生から配られたコードをかざしてください",
      separator: "またはIDとパスワードで",
      schoolIdHint: "学校全体の番号",
      loginIdHint: "あなた個人のID",
      schoolIdPlaceholder: "スクールID",
      loginIdPlaceholder: "生徒ログインID",
      loginButton: "生徒ログインIDでログイン",
      qrGuide: "わくの中にQRコードを合わせてください",
      stopScan: "スキャンを終了する"
    },
    errors: {
      invalidCredentials:
        "ログイン情報を確認してください。スクールID・ログインID・パスワードのいずれかに誤りがある可能性があります。",
      usageExpired:
        "このスクールの利用期限が過ぎているため、スクールAIを利用できません。管理者にお問い合わせください。",
      // テナントのホスト向け。商品名を含めない（FR-06）
      usageExpiredNeutral:
        "このスクールの利用期限が過ぎているため、ご利用いただけません。管理者にお問い合わせください。",
      accountSuspended:
        "このアカウントは現在利用停止中のため、スクールAIを利用できません。先生にお問い合わせください。",
      accountSuspendedNeutral:
        "このアカウントは現在利用停止中のため、ご利用いただけません。先生にお問い合わせください。",
      invalidRequest: "入力内容を確認してください。",
      externalLoginFailed:
        "外部ログインに失敗しました。もう一度お試しください。",
      temporary: "問題が発生しました。時間をおいて再度お試しください。",
      missingLoginId: "ログインIDを入力してください",
      missingPassword: "パスワードを入力してください",
      missingSchoolId: "スクールIDを入力してください",
      missingEmail: "メールアドレスを入力してください",
      auth: {
        invalidEmail: "メールアドレスの形式が正しくありません",
        userDisabled: "アカウントが無効化されています",
        invalidCredential:
          "メールアドレスまたはパスワードが正しくありません。ご確認のうえもう一度お試しください。",
        userNotFound:
          "指定されたメールアドレスのユーザーアカウントがありません",
        operationNotAllowed:
          "メールとパスワードによるサインインが許可されていません",
        tooManyRequests:
          "セキュリティのためアカウントへのアクセスが一時的に制限されました。しばらくしてからお試しください。",
        network:
          "ネットワークエラーが発生しました。接続を確認してもう一度お試しください。"
      }
    }
  },
  checkSchoolId: {
    loginId: "ログインID",
    password: "パスワード",
    search: "検索する",
    goBack: "ログイン画面へ戻る",
    title: "スクールID確認",
    description:
      "ログインIDとパスワードを入力して、スクールIDを確認してください。",
    close: "閉じる",
    schoolId: "スクールID",
    copy: "コピー",
    copied: "コピーしました"
  }
};
